import { useEffect, useState } from "react";
import Navbar from "../../parts/Navbar/Navbar";
import StepBadge from "../../utils/StepBadge/StepBadge";
import CreateDatabaseStepOne from "./CreateDatabaseStepOne/CreateDatabaseStepOne";
import CreateDatabaseStepThree from "./CreateDatabaseStepThree/CreateDatabaseStepThree";
import CreateDatabaseStepTwo from "./CreateDatabaseStepTwo/CreateDatabaseStepTwo";
import "./DatabaseCreateScreen.scss";

export default function DatabaseCreateScreen() {
  const [step, setStep] = useState(1);
  const [stepTitle, setStepTitle] = useState("Configuration");

  useEffect(() => {
    if (step === 1) {
      setStepTitle("Configuration");
      return;
    }
    if (step === 2) {
      setStepTitle("Tables et champs");
      return;
    }
    setStepTitle("Relations");
  }, [step]);

  const stepOne = <CreateDatabaseStepOne navigateToStep={setStep} />;
  let stepComponent = stepOne;
  if (step === 1) {
    stepComponent = stepOne;
  }
  if (step === 2) {
    stepComponent = <CreateDatabaseStepTwo navigateToStep={setStep} />;
  }
  if (step === 3) {
    stepComponent = <CreateDatabaseStepThree navigateToStep={setStep} />;
  }

  return (
    <div>
      <Navbar pageTitle={"Créer un référentiel complexe"} />

      <div className="DatabaseCreateScreen Container">
        <div className="Container-content">
          <div className="Stepper">
            <div className="Stepper-navWrapper">
              <ul className="Stepper-nav">
                <li className="Stepper-header">
                  <StepBadge value={1} active={step === 1} />{" "}
                  <span className={`Stepper-btnLabel ${step === 1 ? " active" : ""}`}>
                    Configuration
                  </span>
                </li>
                <li>
                  <div className="Stepper-divider" />{" "}
                </li>
                <li className="Stepper-header">
                  <StepBadge value={2} active={step === 2} />{" "}
                  <span className={`Stepper-btnLabel ${step === 2 ? " active" : ""}`}>
                    Tables et champs
                  </span>
                </li>
                <li>
                  <div className="Stepper-divider" />{" "}
                </li>
                <li className="Stepper-header">
                  <StepBadge value={3} active={step === 3} />{" "}
                  <span className={`Stepper-btnLabel ${step === 3 ? " active" : ""}`}>
                    Relations
                  </span>
                </li>
              </ul>

              <h2 className="Stepper-title">{stepTitle}</h2>
            </div>

            <div className="Stepper-body">{stepComponent}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
